import React from 'react';
// components
import Modal from 'shared/modals/Modal';
import { Field, FormElement, Form } from '@progress/kendo-react-form';
import { FormInput } from 'shared/forms';
import { emailQuotePDF } from 'src/fetch/pricing';
import { Button } from '@gulfwinds/ui-components';
import errorToastr from 'shared/helpers/errorToastr';
import toastr from 'shared/helpers/toastr';

const EmailQuoteModal = ({
  onClose,
  values,
  initialValues,
  isSubmitting,
  setSubmitting
}) => {

  const handleSubmit = async (values) => {
    try {
      await emailQuotePDF(initialValues.id, values.email);
      toastr('success', 'Quote Emailed Successfully.');
    } catch (error) {
      errorToastr({
        error,
        messagePrefix: 'Failed to send email with quote PDF.'
      });
    }
  };

  const emailRegex = new RegExp(/\S+@\S+\.\S+/);
  const emailValidator = (value) => emailRegex.test(value) ? null : "Please enter a valid email.";

  return (
    <Modal isOpen={true} title={`Email Quote #${initialValues.id}`} handleClose={onClose} containerStyle='medium'>
      <Form
        id='email-quote-form'
        onSubmit={handleSubmit}
        showDeleteButton={false}
        render={({ valueGetter, errors, onChange }) => (
          <FormElement>
            <fieldset>
              <Field id='email' name='email' label='Recipient' component={FormInput} validator={emailValidator} required />
            </fieldset>
            <div className='form-action-bar-right'>
              <div className='flex'>
                <Button primary type='submit' title='Send Quote' />
              </div>
            </div>
          </FormElement>
        )}
      />
    </Modal>
  );
};

export default EmailQuoteModal;
